// @ts-check

import { mutationOptions, queryOptions } from "@tanstack/react-query"
import { createChatProject, getChatProjects } from "../api"

const ChatProjectQueryKeys = {
  CHAT_PROJECTS: () => ["projects"],
}

const FIVE_MINUTES_MS = 5 * 60 * 1000

const ChatProjectQueryOptions = {
  /** @param {string} userToken */
  CHAT_PROJECTS: (userToken) => queryOptions({
    queryKey: ChatProjectQueryKeys.CHAT_PROJECTS(),
    queryFn: ({ signal }) => (
      getChatProjects(userToken, { signal }).then(data => {
        return data.projects
      })
    ),
    staleTime: FIVE_MINUTES_MS,
    enabled: userToken != null,
  }),
}

const ChatProjectMutationOptions = {
  /**
   * @param {Object} params
   * @param {string} params.userToken
   */
  CREATE_NEW_PROJECT: ({ userToken }) => mutationOptions({
    /**
     * @param {Object} params
     * @param {string} params.title
     */
    mutationFn: ({ title }) => (
      createChatProject({ title }, userToken)
    ),
    async onSuccess(data, variables, _, context) {
      await context.client.cancelQueries({ queryKey: ChatProjectQueryKeys.CHAT_PROJECTS() })

      context.client.setQueryData(
        ChatProjectQueryKeys.CHAT_PROJECTS(),
        /** @param {ChatProject[]} projects */
        projects => [...(projects ?? []), data.project]
      )
    },
  }),
}

export {
  ChatProjectQueryKeys,
  ChatProjectQueryOptions,
  ChatProjectMutationOptions,
}
